import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedForum = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="forum" size="100%" color={stroke ?? color} />
);

export { LineRoundedForum };
